import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  tooltip: {
    padding: 24,
    gap: 8,
    width: 400,
    flexDirection: 'row',
  },
  closeIcon: {
    color: neutrals.neutralGrays.grey,
  },
  content: {
    gap: 32,
    width: 319,
  },
  topContent: {
    gap: 4,
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    color: '#252527',
  },
  description: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: '#252527',
  },
  progressBar: {
    width: '100%',
    backgroundColor: neutrals.coldGrays.pearl,
    borderRadius: 100,
    padding: 2,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  progressBarContent: {
    borderRadius: 100,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  progressBarGradient: {
    width: '100%',
    height: '100%',
    borderRadius: 100,
    justifyContent: 'center',
    alignItems: 'center',
  },
  progressBarText: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.white,
  },
  bottomContent: {
    gap: 2.5,
  },
  subtitle: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
  },
  input: {
    width: '100%',
    height: 40,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: neutrals.neutralGrays.titanium,
    paddingVertical: 8,
    paddingHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  inputText: {
    flex: 1,
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 400,
    color: neutrals.neutralGrays.graphite,
  },
  inputFocus: {
    borderColor: FOCUS_COLOR,
  },
  inputCounter: {
    fontSize: 14,
    lineHeight: 21,
    fontWeight: 400,
    color: neutrals.neutralGrays.grey,
  },
});
